var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('router-view',{staticStyle:{"min-height":"calc(100vh - 161px)"}}),(_vm.$store.state.loggedIn && !['/login', '/signup'].includes(_vm.$route.fullPath))?_c('dashboard-core-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }